import { render } from "./PricingPlan.vue?vue&type=template&id=fbc83d6c&scoped=true"
import script from "./PricingPlan.vue?vue&type=script&lang=js"
export * from "./PricingPlan.vue?vue&type=script&lang=js"

import "./PricingPlan.vue?vue&type=style&index=0&id=fbc83d6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc83d6c"]])

export default __exports__